const phoneBind = {
  path: 'phoneBind',
  component: resolve => require(['../../../../pages/home/user/phone-bind'], resolve)
}

export default phoneBind
